import React, { useEffect, useState } from "react";
import { Button, Card, Col, Form, Spinner } from "react-bootstrap";
import { inputChange } from "../../../helpers";
import { PickList } from "primereact/picklist";
import "primereact/resources/themes/bootstrap4-light-blue/theme.css";
import { CustomViewsServices } from "./CustomViewsServices";
import Swal from "sweetalert2";


const CustomViews = ({
  setViews,
  setShowCreateView,
  viewToEdit,
  show,
  gantt,
  setViewToEdit,
}) => {
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [viewForm, setViewForm] = useState({
    title: "",
    new: true,
    public: false,
  });

  const [source, setSource] = useState(CustomViewsServices.initialStatelabels);
  const [target, setTarget] = useState([]);
  const [sourceSelection, setSourceSelection] = useState([]);
  const [targetSelection, setTargetSelection] = useState([]);

  const updateIndex = (items) => {
    return items.map((item, idx) => ({ ...item, index: idx }));
  };

  const crearSelection = () => {
    const pickListElement = document.querySelectorAll(".p-picklist-list");
    pickListElement.forEach((list) => {
      const items = list.querySelectorAll(".p-highlight");
      items.forEach((item) => item.classList.remove("p-highlight"));
    });
  };

  const handleChangeColumns = (e) => {
    setSource(e.source);
    setTarget(e.target);
  };
  const saveView = async (data) => {
    try {
      setSaving(true);

      if (data.new) {
        const result = await CustomViewsServices.createView(data);

        if (result.status === 200) {
          Swal.fire(
            "Guardado",
            "Su Vista ha sido creada correctamente.",
            "success"
          ).then((value) => {
            setViews((prev) => {
              return [...prev, result.data.data];
            });
            setShowCreateView(false);
          });
        }
      } else {
        const result = await CustomViewsServices.updateView(data);
        if (result.status === 200) {
          Swal.fire(
            "Actualizado",
            "Su Vista ha sido actualizada correctamente.",
            "success"
          ).then((value) => {
            setViews((prev) =>
              prev.map((view) =>
                view.IdVista === viewToEdit[0].IdVista
                  ? { ...view, NombreVista: data.title, Publica: data.public }
                  : view
              )
            );
            gantt.render();

            setShowCreateView(false);
          });
        }
      }
    } catch (error) {
      Swal.fire("Error", error, "error");
    } finally {
      setSaving(false);
    }
  };

  const handleSaveViews = async (e) => {
    e.preventDefault();

    const targeOrdenPosition = updateIndex(target);
    const sourceOrdenPosition = updateIndex(source);

    const items = {
      source: sourceOrdenPosition,
      target: targeOrdenPosition,
    };

    const data = {
      ...viewForm,
      ...items,
    };

    saveView(data);
  };

  const loadOneView = async (IdView) => {
    try {
      setLoading(true);
      const result = await CustomViewsServices.getOneView(IdView);
      setViewForm({
        title: result[0][0].title,
        new: false,
        public: result[0][0].Publica,
        idView: result[0][0].IdVista,
      });

      setTarget(
        result[1]
          .filter((col) => col.Habilitada == true)
          .map((col) => {
            return {
              label: CustomViewsServices.initialStatelabels.filter(
                (lb) => lb.value == col.NombreColumna
              )[0].label,
              value: col.NombreColumna,
              idColumn: col.IdNombreColumna,
              index: col.Indice,
            };
          })
      );

      setSource(
        result[1]
          .filter((col) => col.Habilitada == false)
          .map((col) => {
            return {
              label: CustomViewsServices.initialStatelabels.filter(
                (lb) => lb.value == col.NombreColumna
              )[0].label,
              value: col.NombreColumna,
              idColumn: col.IdNombreColumna,
              index: col.Indice,
            };
          })
      );
    } catch (error) {
      Swal.fire("Error", error, "error");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (viewToEdit) {
      loadOneView(viewToEdit[0]?.IdVista);
    }
  }, [show]);
  const handleSelectSource = (e) => {

    setSourceSelection(e.value);
  };

  const handleSelectTarget = (e) => {

    setTargetSelection(e.value);
  };

  return (
    <>
      <div className="container mt-1">
        {loading ? (
          <div className="d-flex justify-content-center">
            <Spinner animation="border" variant="info" role="status" />
          </div>
        ) : (
          <>
            <Form onSubmit={handleSaveViews}>
              <Card>
                <Col md={6} className="mb-3">
                  <Form.Group>
                    <Form.Label>Nombre</Form.Label>
                    <Form.Control
                      size="sm"
                      type="text"
                      value={viewForm.title}
                      required
                      name="title"
                      onChange={(e) => {
                        inputChange(e, setViewForm);
                      }}
                    />
                  </Form.Group>
                </Col>
              </Card>
              <Card className="mt-2">
                <div className=" m-2">
                  <Form.Check
                    type="checkbox"
                    label="La vista será pública ?"
                    checked={viewForm.public}
                    onChange={(e) => {
                      setViewForm((prev) => {
                        return { ...prev, public: e.target.checked };
                      });
                    }}
                  />
                </div>
              </Card>
              <Card className="mt-2">
                <Col className="mt-2">
                  <Form.Group>
                    <PickList
                      metaKeySelection={false}
                      source={source}
                      target={target}
                      sourceHeader="Disponibles"
                      targetHeader="Seleccionado"
                      itemTemplate={(item, idx) => (
                        <span key={idx}>{item?.label}</span>
                      )}
                      onChange={handleChangeColumns}
                      showTargetControls={true}
                      showSourceControls={true}
                      onSourceSelectionChange={handleSelectSource}
                      onTargetSelectionChange={handleSelectTarget}
                      filter
                      filterBy="label"
                      sourceFilterPlaceholder="Buscar..."
                      targetFilterPlaceholder="Buscar..."
                      sourceStyle={{
                        paddingTop: "0px",
                        paddingBottom: "0px",
                        height: "250px",
                      }}
                    />
                  </Form.Group>
                </Col>
              </Card>
              <hr />
              <div className="mt-2 d-flex  justify-content-end">
                <Button disabled={saving} variant="success" type="submit" block>
                  {saving ? (
                    <> {viewForm.new ? "Guardando...." : "Actualizando...."}</>
                  ) : (
                    <>{viewForm.new ? "Guardar Vista" : "Actualizar Vista"}</>
                  )}
                </Button>
              </div>
            </Form>
          </>
        )}
      </div>
    </>
  );
};

export default CustomViews;
